module.exports = __webpack_public_path__ + "img/02.924f4dce.svg";